import { getTemplateNavHeaderPrimaryStyles } from './NavHeaderPrimary.styles'

const t = document.createElement('template')
t.innerHTML = `
<li class="nav-item"><slot></slot></li>
`

class NavHeaderMobileItem extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderPrimaryStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderMobileItem connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-mobile-item')) {
  customElements.define('ts-navheader-mobile-item', NavHeaderMobileItem)
}
export { NavHeaderMobileItem }
